import React, { useCallback } from 'react';
import { Modal } from 'antd';
import { ButtonIcon } from 'components/common';
import {
  SmartButton,
  SmartRow,
  SmartScanner,
  SmartFormLabel,
  SmartText,
} from '../../SmartComponent';
import { useTranslation } from 'react-i18next';

type OrderFinishDialogProps = {
  sLocation: string;
  tLocation: string;
  onSubmit: (order: string | undefined) => void;
};
export default function OrderFinishDialog(
  props: OrderFinishDialogProps
): JSX.Element {
  const { sLocation, tLocation, onSubmit } = props;
  const { t } = useTranslation();
  /**
   * handle scan changed event
   */
  const handleScannerChange = useCallback(
    async (value?: string) => {
      onSubmit(value);
    },
    [onSubmit]
  );
  /**
   * return modal title
   * @returns {JSX.Element}
   */
  const Title = (): JSX.Element => {
    return (
      <SmartRow justify="center">
        <ButtonIcon className="bi-emoji-smile" />
        <div style={{ marginLeft: 5 }}>{'Merge Done!'}</div>
      </SmartRow>
    );
  };
  const copywrite = 'Scan next source location to start next merge';
  return (
    <Modal visible width={300} title={<Title />} footer={null} closable={false}>
      <SmartRow>
        <SmartFormLabel>{t("smart.movemerge.from")}</SmartFormLabel>
        <SmartText>{sLocation}</SmartText>
      </SmartRow>
      <SmartRow>
        <SmartFormLabel>{t("smart.movemerge.to")}</SmartFormLabel>
        <SmartText>{tLocation}</SmartText>
      </SmartRow>
      <SmartRow>{copywrite}</SmartRow>
      <SmartRow style={{ marginTop: 20 }}>
        <SmartScanner onChangeValue={(value) => handleScannerChange(value)} />
      </SmartRow>
      <SmartRow style={{ marginTop: 20 }} justify="center">
        <SmartButton
          style={{ width: 200 }}
          onClick={() => {
            handleScannerChange(undefined);
          }}
        >
          
          {t("smart.movemerge.nextMerge")}
        </SmartButton>
      </SmartRow>
    </Modal>
  );
}
